import { Fonts } from 'src/typography';

import { normalAnimations, normalTransitions } from './shared';

export const getStyledTheme = ({ colors, embeddedMenu, shadows, breakpoints, spaces, customized }) => {
  // stupid styled system stuff
  breakpoints.map = (...args) => Object.values(breakpoints.values).map(...args);
  return {
    breakpoints,
    colors,
    embeddedMenu,
    fontFamily: Fonts.matter,
    shadows,
    animations: normalAnimations,
    transitions: normalTransitions,
    spaces,
    customized,
  };
};
